<template>
  <SwitchGroup>
    <div class="flex flex-row items-center gap-2">
      <SwitchLabel v-if="label" class="text-label-large cursor-pointer select-none">{{
        label
      }}</SwitchLabel>
      <Switch
        :model-value="value"
        as="template"
        v-slot="{ checked }"
        :disabled="disabled"
        @update:model-value="(value) => emit('valueUpdated', value)"
      >
        <button
          ref="button"
          class="relative box-border inline-flex h-8 w-13 shrink-0 items-center rounded-full border-2 transition-colors"
          :disabled="disabled"
          :class="[
            checked && !disabled && 'bg-primary border-primary cursor-pointer',
            !checked && !disabled && 'bg-surface-container-highest border-outline cursor-pointer',
            checked && disabled && 'bg-on-surface/[12%] cursor-auto! border-transparent',
            !checked &&
              disabled &&
              'bg-surface-container-highest/[12%] border-on-surface/[12%] cursor-auto!',
          ]"
        >
          <span
            :class="[
              checked && !disabled && 'bg-on-primary left-5.5 h-6 w-6',
              !checked && !disabled && 'bg-outline left-1 h-4 w-4',
              checked && disabled && 'bg-surface left-5.5 h-6 w-6',
              !checked && disabled && 'bg-on-surface/[38%] left-1 h-4 w-4',
              pressed && 'h-6 w-6',
            ]"
            class="text-primary absolute flex items-center justify-center rounded-full transition-all"
          >
            <BaseIcon v-if="checked" size="18" :class="[disabled && 'text-on-surface/[38%]']"
              >check</BaseIcon
            >
          </span>
        </button>
      </Switch>
    </div>
  </SwitchGroup>
</template>
<script lang="ts" setup>
  import { Switch, SwitchLabel, SwitchGroup } from '@headlessui/vue'
  import { useMousePressed } from '@vueuse/core'
  import { useTemplateRef } from 'vue'
  import BaseIcon from '../icon/BaseIcon.vue'

  interface Props {
    value: boolean
    disabled?: boolean
    label?: string
  }

  defineProps<Props>()

  const button = useTemplateRef<HTMLElement>('button')
  const { pressed } = useMousePressed({ target: button })

  const emit = defineEmits<{
    (e: 'valueUpdated', value: boolean): void
  }>()
</script>
